<div class="container-fluid">
    <app-report reportId="financeImpactDashboard" screen="DASHBOARDFINANCEIMPACT"></app-report>
</div>
